import { createReducer } from "@reduxjs/toolkit";
import {
  getUser,
  signInUser,
  setLanguage,
  setTheme,
  syncTickers,
  deleteTicket,
  updateTicket,
} from "../AsyncThunk";

const initialState = {
  userSettings: {
    theme: "light",
    language: "en",
  },
  ticketsList: [],
  user: null,
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setLanguage.fulfilled, (state, action) => {
    if (!state.userSettings) {
      state.userSettings = { ...initialState.userSettings };
    }
    state.userSettings.language = action.payload;
  });
  builder
    .addCase(setTheme.fulfilled, (state, action) => {
      if (!state.userSettings) {
        state.userSettings = { ...initialState.userSettings };
      }
      state.userSettings.theme = action.payload;
    })
    .addCase(syncTickers.fulfilled, (state, action) => {
      state.lastSyncedAt = action.payload.syncedAt;
    })
    .addCase(getUser.fulfilled, (state, action) => {
      if (action.payload?.userProfile?.language) {
        state.userSettings.language = action.payload.userProfile.language;
      }
    })
    .addCase(signInUser.fulfilled, (state, action) => {
      if (action.payload?.userProfile?.language) {
        state.userSettings.language = action.payload.userProfile.language;
      }
    })
    .addCase(deleteTicket.fulfilled, (state, action) => {
      if (action.payload.isLocal) {
        state.ticketsList = state.ticketsList.filter(
          (ticket) => ticket.id !== action.payload.data
        );
      }
    })
    .addCase(updateTicket.fulfilled, (state, action) => {
      if (action.payload.isLocal) {
        const ticketIndex = state.ticketsList.findIndex(
          (ticket) => ticket.id === action.payload.data.id
        );
        if (ticketIndex !== -1) {
          state.ticketsList[ticketIndex] = action.payload.data;
        } else {
          state.ticketsList.push(action.payload.data);
        }
      }
    })
});
